module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "top"
  }, [(_vm.show) ? _c('ul', _vm._l((_vm.listdata), function(item) {
    return _c('li', [_c('p', [_vm._v(_vm._s(item.value))]), _c('p', [_vm._v(_vm._s(item.name))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', [(_vm.show) ? _c('v-bars', {
    attrs: {
      "regionBar": _vm.regionBar
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.show) ? _c('v-twoWayBar', {
    attrs: {
      "productBar": _vm.productBar
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.show) ? _c('v-pie', {
    attrs: {
      "distributedBar": _vm.distributedBar
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [(_vm.show) ? _c('v-table', {
    attrs: {
      "povertyAlleviaList": _vm.povertyAlleviaList
    }
  }) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61516139!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/helper/index.vue
// module id = 2020
// module chunks = 2